module.exports = __webpack_public_path__ + "img/contact-sebastianfredriksson.2cdc93d4.png";